export default {
    path: '/risks',
    name: 'risks',
    component: () => import('../components/risk/Layout'),
    redirect: { name: 'RiskList' },
    meta: {
        breadcrumb: 'risk.risks',
    },
    children: [
        {
            name: 'RiskList',
            path: '',
            component: () => import('../views/risk/List'),
            meta: {
                breadcrumb: 'global.list',
            },
        },
        {
            name: 'RiskCreate',
            path: 'new',
            component: () => import('../views/risk/Create'),
            meta: {
                breadcrumb: 'global.add',
            },
        },
        {
            name: 'RiskUpdate',
            path: ':id/edit',
            component: () => import('../views/risk/Update'),
            meta: {
                breadcrumb: 'risk.risk',
            },
        },
        {
            name: 'RiskShow',
            path: ':id',
            component: () => import('../views/risk/Show'),
            meta: {
                breadcrumb: 'risk.risk',
            },
        },
    ]
};
